import React from "react";
import "../../../../assets/css/public.scss";
import PublicHeader from "./PublicHeader";
import PublicFooter from "./PublicFooter";
import {widget} from "../../../modulesCompiler";
import CookiesAlert from "./CookiesAlert";
import TagManager from "react-gtm-module";

const tagManagerArgs = {
    gtmId: 'GTM-KS7272Z'
}

TagManager.initialize(tagManagerArgs);


const PublicLayout = (props) => {
    let Component = props.component;

    return (
        <div>
            <PublicHeader />

            <div style={{minHeight: 400}}>
                <Component {...props} />
            </div>

            <PublicFooter />
            <CookiesAlert />
            {widget("orders.BasketDrawer")}
        </div>
    )
}

export default PublicLayout;
